<template>
    <div style="width: 100%; text-align: initial;">
      <div id="deactivateModal" class="modal deact"  style="width: 50%;">
                <div class="modal-content">
                    <h4 v-if="inactDevice">{{$t('devices.one_title')}} {{inactDevice.number}}</h4>
                    <div class="row">
                        <div class="col s12">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <label :for="'device_inactcause_'+group">{{$t('devices.cause')}}:</label>
                            <div class="input-field">
                              <input :id="'device_inactcause_'+group" type="text" v-model="cause" />
                            </div>
                        </div>
                    </div>
                      <div class="row">
                        <div class="col s12">
                            <label><input type="checkbox" checked="checked"> <span data-v-6bc2674c="">{{$t('devices.dont_show_mobile_app')}}</span></label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer row">
                    <div class="col s6">
                        <button class="modal-close waves-effect waves-green btn-small emptygreen" style="width: 100%">{{$t('menu.buttons.cancel')}}</button>
                    </div>
                    <div class="col s6">
                        <button v-on:click="inactivate(inactDevice)" class="waves-effect waves-green btn-small green" style="width: 100%">{{$t('menu.ok')}}</button>
                    </div>
                </div>
        </div>
        <div id="permadeactivateModal" class="modal act"  style="width: 50%;">
                <div class="modal-content">
                    <h4 v-if="inactDevice">{{$t('devices.do_you_want_to_activate_point')}}  {{inactDevice.number}} ?</h4>
                <div class="modal-footer row">
                    <div class="col s6">
                        <button class="modal-close waves-effect waves-green btn-small emptygreen" style="width: 100%">{{$t('menu.buttons.cancel')}}</button>
                    </div>
                    <div class="col s6">
                        <button v-on:click="activate(inactDevice)" class="waves-effect waves-green btn-small green" style="width: 100%">{{$t('devices.activate')}}</button>
                    </div>
                </div>
            </div>
        </div>
         <div id="permadeactivateModal" class="modal pact"  style="width: 50%;">
                <div class="modal-content">
                    <h4 v-if="inactDevice">{{$t('devices.do_you_want_to_delete_point')}}  {{inactDevice.number}} ?</h4>
                <div class="modal-footer row">
                    <div class="col s6">
                        <button class="modal-close waves-effect waves-green btn-small emptygreen" style="width: 100%">{{$t('menu.buttons.cancel')}}</button>
                    </div>
                    <div class="col s6">
                        <button v-on:click="permaDelete(inactDevice)" class="waves-effect waves-green btn-small red" style="width: 100%">{{$t('devices.delete')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="changeModal" class="modal pchange"  style="width: 50%;">
                <div class="modal-content">
                    <template v-if="selchangetodevs[group]">
                        {{$t('devices.one_title')}}: {{nameDevices(checkedDevices)}}
                        <br/>
                        {{$t('devices.change_to')}}:
                        {{{'true': $t('devices.actives'), 'false': $t('devices.inactives')}[selchangetodevs[group].split(":")[0]]}}
                        {{nameForZone(selchangetodevs[group].split(":")[1])}}
                        <template v-if="dev_types[selchangetodevs[group].split(':')[2]] != undefined">
                            {{dev_types[selchangetodevs[group].split(':')[2]].name}}
                        </template>
                    </template>
                <div class="modal-footer row">
                    <div class="col s6">
                        <button class="modal-close waves-effect waves-green btn-small emptygreen" style="width: 100%">{{$t('menu.buttons.cancel')}}</button>
                    </div>
                    <div class="col s6">
                        <button v-on:click="changeTo(selectedoptions[group].active, selectedoptions[group].zone, selectedoptions[group].dt, group)" class="modal-close waves-effect waves-green btn-small green" style="width: 100%">{{$t('devices.change_button')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row header" style="padding-bottom: 15px;" v-if="edit_devices">
            <div class="col m2 ">
                {{$t('devices.select_label')}}:
            </div>
            <dropdown :close="true" :w="3">
                <div class="label dropdown-trigger" :data-target='"mass"+group'>
                    <template v-if="seldevs[group]">
                        <template v-if="seldevs[group].length == 0">{{$t('menu.buttons.select')}}</template>
                        <template v-if="seldevs[group] == 'true:null:null'">{{$t('devices.active')}}</template>
                        <template v-else-if="seldevs[group] == 'false:null:null'">{{$t('devices.inactive')}}</template>
                        <template v-else-if="seldevs[group].length > 0 && seldevs[group].split(':')[1] != 'null'">{{$t('devices.zone')}}: 
                             <template  v-for="zone in place.zones">
                                <template v-if="seldevs[group] == ('null:'+zone.id+':null')">{{zone.name}}</template>
                            </template>
                        </template>
                        <template v-else-if="seldevs[group].length > 0 && seldevs[group].split(':')[2] != 'null'">{{$t('devices.type')}}:
                            {{dev_types[seldevs[group].split(':')[2]].name}}
                        </template>
                    </template>
                    <ul :id='"mass"+group' class='dropdown-content'>
                        <li v-on:click="selectItems(true, null, null, group)">{{$t('devices.active')}}</li>
                        <li v-on:click="selectItems(false, null, null, group)">{{$t('devices.inactive')}}</li>
                        <li v-on:click="selectItems(null, zone.id, null, group)" v-for="zone in place.zones" v-if="zoneIds(items).indexOf(zone.id) > -1">
                            {{$t('devices.zone')}}: {{zone.name}}
                        </li>
                        <li v-on:click="selectItems(null, null, dt.id, group)" v-for="dt in dev_types" v-if="devTypeIds(items).indexOf(dt.id) > -1">
                            {{$t('devices.type')}}: {{dt.name}}
                        </li>
                    </ul>

                </div>
            </dropdown>
            <div class="col m2 " v-if="checkedDevices.length > 0">
                {{$t('devices.change_selected_to')}}:</div>
            <dropdown :close="true" :w="3" v-if="selchangetodevs[group]">
                <div class="label dropdown-trigger" :data-target='"massdo"+group' v-show="checkedDevices.length > 0">
                    <template v-if="selchangetodevs[group].length == 0">{{$t('menu.buttons.select')}}</template>
                    <template v-if="selchangetodevs[group] == 'true:null:null'">{{$t('devices.active')}}</template>
                    <template v-else-if="selchangetodevs[group] == 'false:null:null'">{{$t('devices.inactive')}}</template>
                    <template v-else-if="selchangetodevs[group].length > 0 && selchangetodevs[group].split(':')[1] != 'null'">{{$t('devices.zone')}}: 
                        <template  v-for="zone in place.zones">
                            <template v-if="selchangetodevs[group] == ('null:'+zone.id+':null')">{{zone.name}}</template>
                        </template>
                    </template>
                    <template v-else-if="selchangetodevs[group].length > 0 && selchangetodevs[group].split(':')[2] != 'null'">{{$t('devices.type')}}: {{dev_types[selchangetodevs[group].split(':')[2]].name}}
                    </template>
                    <ul :id='"massdo"+group' class='dropdown-content'>
                        <li v-on:click="changeToSelected(true, null, null, group)">{{$t('devices.active')}}</li>
                        <li v-on:click="changeToSelected(false, null, null, group)">{{$t('devices.inactive')}}</li>
                        <li v-on:click="changeToSelected(null, zone.id, null, group)" v-for="zone in place.zones">
                            {{$t('devices.zone')}}: {{zone.name}}
                        </li>
                        <li v-on:click="changeToSelected(null, null, dt.id, group)" v-for="dt in devTypesFromTheSameCategory(items)">
                            {{$t('devices.type')}}: {{dt.name}}
                        </li>

                    </ul>
                </div>
            </dropdown>
            <a v-on:click="changeAsk()" class="waves-effect waves-light btn-small red" v-if="edit_devices == true && checkedDevices.length > 0">{{$t('devices.change_button')}}</a>
        </div>
        <div class="row header" style="padding-bottom: 20px;">
            <div class="col m1 offset-m1 text-bold">{{$t('devices.number')}}</div>
            <div class="col m2 text-bold">{{$t('devices.dev_type')}}</div>
            <div class="col m3 text-bold">{{$t('devices.preparations')}}</div>
            <div class="col m3 text-bold">{{$t('devices.zone')}} </div>
        </div>
        <div class="row" v-for="device in listItems" :class="{ permanentlyremove: device.permanently_removed }">
            <div class="col m1"><label>
                    <input type="checkbox" :value=device.id v-model="checkedDevices"  :disabled="!edit_devices"/>
                    <span></span>
                </label>
            </div>
            <div class="col m1">
                <div class="input-field" v-if="needsChangeNumber(fromsuggestions[device.id], device) == false || rejects.indexOf(device.id) > -1">
                    <input :id="'device_number_'+device.id" type="text" v-model="device.number" :disabled="!edit_devices"/>
                </div>
                 <div class="input-field needchangefield"  v-else>
                    <input :id="'device_number_'+device.id" type="text" v-model="fromsuggestions[device.id].number" disabled="true"/>
                </div>
            </div>
            <div class="col m2" v-if="dev_types[device.dev_type_id]">
                
                <template v-if="needsChangeDevType(fromsuggestions[device.id], device) == false || rejects.indexOf(device.id) > -1">
                      <template v-if="!edit_devices">{{dev_types[device.dev_type_id].name}}</template>
                    <select :id="'device_devtype_'+device.id"  v-model="device.dev_type_id" v-else>
                        <option v-for="dt in dev_types" :value="dt.id">{{dt.name}}</option>
                    </select>
                </template>
                <template v-else>
                   <select :id="'device_devtype_needchange_'+device.id" class="needchangefield" v-model="fromsuggestions[device.id].dev_type_id" disabled="true">
                        <option v-for="dt in dev_types" :value="dt.id">{{dt.name}}</option>
                    </select>
                </template>
            </div>
            <div class="col m3" style="font-size: 10px;">
                {{substancesForDevice(device)}}
            </div>
            <div class="col m2">
                <template v-if="needsChangeZone(fromsuggestions[device.id], device) == false || rejects.indexOf(device.id) > -1">
                    <select :id="'device_zoneid_'+device.id"  v-model="device.zone_id" :disabled="!edit_devices">
                        <option v-for="zone in place.zones" :value="zone.id">{{zone.name}}</option>
                        <option :value="null">-</option>
                    </select>
                </template>
                <template v-else>
                   <select :id="'device_zoneid_needchangefield_'+device.id"  class="needchangefield" v-model="fromsuggestions[device.id].zone_id" disabled="true">
                        <option v-for="zone in place.zones" :value="zone.id">{{zone.name}}</option>
                        <option :value="null">-</option>
                    </select>
                </template>
            </div>
            <div class="col m3" v-if="place.editable && edit_devices">
                <a class="btn btn-small grey" v-if="device.active && fromsuggestions[device.id] == undefined || rejects.indexOf(device.id) > -1" v-on:click="inactivateAsk(device)">{{$t('devices.deactivate')}}</a>
                <a class="btn btn-small grey" v-if="!device.active" v-on:click="activateAsk(device)">{{$t('devices.activate')}}</a>
                <a class="btn btn-small red" v-if="!device.active" v-on:click="permaDeleteAsk(device)">{{$t('devices.delete')}}</a>
                <template v-if="loads">
                    <button class="waves-effect waves-light btn-large cancelbutton" v-if="fromsuggestions[device.id] != undefined && rejects.indexOf(device.id) == -1" v-on:click="applySuggestion(device.id)">{{fromsuggestions[device.id].active == false ? $t('devices.deactivate') : $t('devices.accept')}}</button>
                    <button class="waves-effect waves-light btn-large emptygreen" v-if="fromsuggestions[device.id] != undefined && rejects.indexOf(device.id) == -1" v-on:click="rejects.push(device.id)">{{$t('devices.reject')}}</button>
                </template>
            </div>
        </div>
         <div class="row" style="margin-top: 25px;">
                <div class="col  offset-l8 s4 l2">
                    <a v-on:click="cancelEditDevices()" class="waves-effect waves-light btn-large cancelbutton" v-if="edit_devices">{{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col l2 s4">
                    <a v-on:click="editDevices()" class="waves-effect waves-light btn-large emptygreen" v-if="edit_devices == false && place.editable">{{$t('menu.buttons.edit')}}</a>
                    <a v-on:click="saveDevices()" class="waves-effect waves-light btn-large emptygreen" v-if="edit_devices == true">
                        <div v-if="saving_devices" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving_devices == false ? $t('menu.buttons.save_changes') : ""}}
                    </a>
                </div>
            </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            saving: false,
            saving_devices: false,
            checkedDevices: [],
            edit_devices: false,
            inactDevice: undefined,
            typeofdeactivate: "permanently",
            selectedoptions: {},
            seldevs: {},
            selchangetodevs: {},
            substances: {},
            cause: "",
            rejects: []
        }
    },
    props: { items: Array, place: Object, dev_types: Object, group: String, doseslookup: Object, suggestions: Object, fromsuggestions: Object, loads: Boolean, show_inactive: Boolean },
    created(){
        this.selchangetodevs[this.group] = ""
        this.seldevs[this.group] = ""
        this.selectedoptions[this.group] = {}
    },
    mounted(){
        this.loadSubstances();
        
    },
    computed: {
        needsChangeNumber() {
            return function(change, device){
                if(change == undefined){
                    return false;
                }
                if(change.number == undefined){
                    return false;
                }
                if (change.number != device.number) {
                    return true;
                }
                return false;
            }
        },
        needsChangeDevType(){
            return function(change, device){
                if(change == undefined){
                    return false;
                }
                if(change.dev_type_id == undefined){
                    return false;
                }
                if (change.dev_type_id != device.dev_type_id) {
                    return true;
                }
                return false;
            }
        },
        needsChangeZone(){
            return function(change, device){
                if(change == undefined){
                    return false;
                }
                if(change.zone_id == undefined){
                    return false;
                }
                if (change.zone_id != device.zone_id) {
                    return true;
                }
                return false;
            }
        },
        listItems() {
            var that = this;
            return _.filter(that.items, function(item) {
                if (that.show_inactive == false) return item.active == true && item.deleted_permanently == undefined;
                else return true;
            });
        }
    },
    methods: {
      async loadSubstances(){
         var response = await axios.get('/substances.json');
         this.substances = _.keyBy(response.data, 'id');
      },
      editDevices() {
          this.edit_devices = true;
          this.old_devices = _.cloneDeep(this.items);
          this.$forceUpdate();
      },
      cancelEditDevices() {
          this.edit_devices = false;
          this.items = _.cloneDeep(this.old_devices);
          this.checkedDevices = [];
           this.$forceUpdate();
      },
      applySuggestion: function(device_id){
            var that = this;
            var suggestion = this.fromsuggestions[device_id];
            var devlookup = _.keyBy(that.items, 'id');
            if(suggestion.active == undefined){
                devlookup[device_id].number = suggestion.number;
                devlookup[device_id].dev_type_id = suggestion.dev_type_id;
                devlookup[device_id].zone_id = suggestion.zone_id;
            }else{
                devlookup[device_id].active = false;
            }
            this.rejects.push(device_id);
            that.editDevices();
            
            // if(that.suggestions.deactivates.length > 0){
            //     var devlookup = _.keyBy(that.devices, 'id');
            //     for(var j = 0; j != that.suggestions.deactivates.length; j++){
            //         var suggestion = that.suggestions.deactivates[j];
            //         devlookup[suggestion].active = false;
            //     }
            //     that.show_inactive = true;
            //     that.editDevices();
            // }
            // if(that.suggestions.temporary_inactivate.length > 0){
            //     var devlookup = _.keyBy(that.devices, 'id');
            //     for(var j = 0; j != that.suggestions.temporary_inactivate.length; j++){
            //         var suggestion = that.suggestions.temporary_inactivate[j];
            //         devlookup[suggestion.device_id].active = false;
            //     }
            //     that.show_inactive = true;
            //     that.editDevices();
            // }
    },
      async saveDevices() {
        var changes = _.differenceBy(this.old_devices, this.items, function(a) {
            return "" + a.id + "," + a.active + "," + a.number + "," + a.zone_id + "," + a.dev_type_id + "," + a.temporary_inactive_cause + "," + a.permanently_removed;
        });
        var changedids = _.map(changes,  'id');
        var diffe = _.filter(this.items, function(item) {
          return _.includes(changedids, item.id);
        });
        if(this.fromsuggestions.length > 0){
            axios.post('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.suggestions.inspection_id + '/devices/multiple_devices_update.json', {devices: {updates: _.keyBy(diffe, 'id')}})
        }else{
            axios.post('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/devices/multiple_devices_update.json', {devices: {updates:  _.keyBy(diffe, 'id')}})
        }
        this.edit_devices = false;
        this.old_devices = _.cloneDeep(this.items);
      },
      devTypesFromTheSameCategory(items) {
          var dtids = _.map(_.values(_.pick(this.dev_types, _.uniq(_.map(items, 'dev_type_id')))), 'device_category_id')
          return _.filter(this.dev_types, function(dt){ return dtids.indexOf(dt.device_category_id) > -1})
      },
      devTypeIds(items) {
          return _.uniq(_.map(items, 'dev_type_id'))
      },
      zoneIds(items) {
          return _.uniq(_.map(items, 'dev_type_id'))
      },
      selectItems(active, zone, dev_type, group) {
          this.checkedDevices = [];
          this.seldevs[group] = ""+active+":"+zone+":"+dev_type
          for (var dev in this.items) {
            if (active != null) {
              if(this.items[dev].active == active) this.checkedDevices.push(this.items[dev].id);
            }
            if (zone != null) {
              if(this.items[dev].zone_id == zone) this.checkedDevices.push(this.items[dev].id);
            }
            if (dev_type != null) {
              if(this.items[dev].dev_type_id == dev_type) this.checkedDevices.push(this.items[dev].id);
            }
          }
        },
        changeToSelected(active, zone, dev_type, group) {
          this.selchangetodevs[group] = ""+active+":"+zone+":"+dev_type;
          this.selectedoptions[group].active = active;
          this.selectedoptions[group].zone = zone;
          this.selectedoptions[group].dt = dev_type;
          this.$forceUpdate();

        },
        changeTo(active, zone, dev_type, group) {
          for (var dev in this.items) {
            if (active != null && this.checkedDevices.indexOf(this.items[dev].id) > -1) {
                this.items[dev].active = active;
            }
            if (zone != null && this.checkedDevices.indexOf(this.items[dev].id) > -1) {
                this.items[dev].zone_id = zone;
            }
            if (dev_type != null && this.checkedDevices.indexOf(this.items[dev].id) > -1) {
                this.items[dev].dev_type_id = dev_type;
            }
          }
        },
        activateAsk(device) {
          var elems = this.$el.querySelectorAll('.modal.act');
          this.instances = M.Modal.init(elems, {});
          this.instances[0].open()
          this.inactDevice = device;
        },
        activate(device) {
            device.active = true;
            this.instances[0].close()
        },
        nameForZone(zone){
            var foundZone = _.keyBy(this.place.zones, 'id')[zone];
            if(foundZone != undefined){
                return foundZone.name;
            }
        },
        substancesForDevice(device){
            var outlist = [];
            if(this.doseslookup[device.id] != undefined){
                for (var i = this.doseslookup[device.id].length - 1; i >= 0; i--) {
                    var dose = this.doseslookup[device.id][i];
                    if(this.substances[dose.substance_id] != undefined){
                        var out = "";
                        if(dose.dose_change == false){
                            if(dose.dosage > 0){
                                out = out + dose.dosage + " " + dose.dosage_unit
                            }
                            out = out + " " + this.substances[dose.substance_id].name;
                        }else{
                            if(dose.new_dose != 0){
                                if(dose.new_dose > 0){
                                    out = out + dose.new_dose + " " + dose.dosage_unit
                                }
                                out = out + " " + this.substances[dose.substance_id].name;
                            }
                        }
                        if(out.length > 0) outlist.push(out);
                    }
                }
            }
            return outlist.join(", ")
        },
        nameDevices(ids){
            return _.map(_.pick(_.keyBy(this.items, 'id'), ids), 'number').join(", ")
        },
        inactivateAsk(device) {
            var elems = this.$el.querySelectorAll('.modal.deact');
            this.instances = M.Modal.init(elems, {});
            this.instances[0].open()
            this.inactDevice = device;
        },
        changeAsk() {
            var elems = this.$el.querySelectorAll('.modal.pchange');
            this.instances = M.Modal.init(elems, {});
            this.instances[0].open()
        },
        inactivate(device) {
            device.active = false;
            device.temporary_inactive_cause = this.cause;
            this.instances[0].close()
        },
        permaDeleteAsk(device) {
          var elems = this.$el.querySelectorAll('.modal.pact');
          this.instances = M.Modal.init(elems, {});
          this.instances[0].open()
          this.inactDevice = device;
        },
        permaDelete(device) {
          device.permanently_removed = true;
          this.instances[0].close()
        },
    },

}
</script>
<style scoped>
  .btn{
    margin-bottom: 5px;
  }
  .btn-large /deep/ {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.dropdown-trigger{
    border: 1px solid rgb(140, 140, 140) !important;
    border-radius: 3px;
    padding: 2px;
    padding-left: 5px;
}
select{
    height: 100%;
    color: rgba(0,0,0,1.0);
}
/deep/ .dropdown-content li{
    min-height: 25px !important;
}
.needchangefield input, select.needchangefield{
    border: red solid 3px !important;
}
.permanentlyremove{
    opacity: 0.5;
}
</style>